module.exports = require("./../../_gen/starling/events/TouchProcessor");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/events/TouchProcessor.js
// module id = 189
// module chunks = 0